import React, { useEffect, useState } from 'react';
import { FiSearch, FiX } from 'react-icons/fi';
import { LOGO_ICON_SRC } from '../../config/branding';
import {
  isPostsShellCompactViewport,
  POSTS_SHELL_COMPACT_MQ,
} from '../../newsintelligence/support/openDiscussions/lib/feedViewMode';
import { STORAGE_BOX_LOCK_LABEL, STORAGE_BOX_ROOT_LABEL } from '../constants';
import { useStorageBox } from '../StorageBoxContext';

/** Short labels for the cramped mobile toolbar search field. */
const STORAGE_BOX_MOBILE_SEARCH_PLACEHOLDER = 'Storage box';

export default function StorageBoxSearchField({ className = '', compact = false }) {
  const { readOnly, searchQuery, setSearchQuery, clearSearch, vaultScope } = useStorageBox();
  const inLockFolder = vaultScope === 'lock';
  const [isMobileSearch, setIsMobileSearch] = useState(() => isPostsShellCompactViewport());

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mq = window.matchMedia(POSTS_SHELL_COMPACT_MQ);
    const sync = () => setIsMobileSearch(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  if (readOnly) return null;

  const wrapClass = [
    'sb-drive-search-wrap',
    'sb-drive-search-wrap--brand',
    compact ? 'sb-drive-search-wrap--compact' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const placeholder = (() => {
    if (compact) {
      return inLockFolder ? STORAGE_BOX_LOCK_LABEL : 'Search folders & files';
    }
    if (isMobileSearch) {
      return inLockFolder ? STORAGE_BOX_LOCK_LABEL : STORAGE_BOX_MOBILE_SEARCH_PLACEHOLDER;
    }
    return inLockFolder ? `Search in ${STORAGE_BOX_LOCK_LABEL}` : `Search in ${STORAGE_BOX_ROOT_LABEL}`;
  })();

  const ariaLabel = inLockFolder
    ? `Search in ${STORAGE_BOX_LOCK_LABEL}`
    : `Search in ${STORAGE_BOX_ROOT_LABEL}`;

  return (
    <div className={wrapClass}>
      <FiSearch className="sb-drive-search-icon" aria-hidden />
      <input
        type="text"
        role="searchbox"
        className="sb-drive-search"
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        aria-label={ariaLabel}
        autoComplete="off"
      />
      {searchQuery ? (
        <button type="button" className="sb-drive-search-clear" onClick={clearSearch} aria-label="Clear search">
          <FiX />
        </button>
      ) : (
        <img src={LOGO_ICON_SRC} alt="" className="sb-drive-search-logo" aria-hidden />
      )}
    </div>
  );
}
